<template>
  <SharedLink
    :link="link"
    class="m-auto rounded-md border px-4 py-2 text-center mobile:!text-base"
    :style="{
      color: `${textColor}`,
      backgroundColor: `${btnColor}`,
      borderColor: `${borderColor}`,
      borderRadius: `${buttonBorder}`,
      width: `${buttonSize}`,
    }"
  >
    {{ mgnlProps.ctaText }}
  </SharedLink>
</template>

<script lang="ts" setup>
import { ButtonBuilder, WrapperProps } from '~/components/Shared/MagnoliaElements/Button/Button.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);
const mgnlProps = ButtonBuilder.build(props);

const { $domain } = useNuxtApp();

const textColor = magnoliaGetters.getHexColor(mgnlProps.ctaTextColor);
const btnColor = magnoliaGetters.getHexColor(mgnlProps.buttonColor);
const borderColor = magnoliaGetters.getHexColor(mgnlProps.borderColor);
const buttonSize = `${mgnlProps.buttonSize}rem`;
const buttonBorder = `${mgnlProps.buttonCorner}px`;

const link = computed(() => magnoliaGetters.getLinkAndName({
  switchable: mgnlProps.switchable,
  linkTargetMode: mgnlProps.linkTargetMode,
  showCtaAsPdf: mgnlProps.showCtaAsPdf,
  pdfLinkInDam: mgnlProps.pdfLinkInDam,
}, $domain.cmsAssetDomainPath,
mgnlProps.switchable?.intLinkParam,
));
</script>
